import * as React from "react";

export interface IFancyDropdownOptionProps {
  fontAwesomeIcon?: string;
  isSelected?: boolean;
  text: string;
  value: string;
  extraListItemCSSClass?: string;
  clipboardText?: string;
  onSelected?: (event: any) => any;
}

export const FancyDropdownOption = (props: IFancyDropdownOptionProps) => {

  let emCSSclasses = "CAL-currentViewCheck fa";
  emCSSclasses += " ";
  if (props.isSelected) {
    emCSSclasses += "fa-check fd-selected ";
  } else {
    emCSSclasses += "fd-unselected ";
  }

  const icon = props.fontAwesomeIcon === undefined ? "" : props.fontAwesomeIcon;
  const fontAwesomeIconCSSclass = "fa icon " + icon;

  let liCSSclass = "js-nav-system__subnav__item";
  if (props.extraListItemCSSClass !== undefined) { liCSSclass += " " + props.extraListItemCSSClass; }

  const dataClipboardText = props.clipboardText === undefined ? "" : props.clipboardText;

  let text = props.text;
  if (text.trim() === "") {
    text = "(blank)";
  }
  text = text + " ";

  return (
    <li className={liCSSclass} value={props.value} onClick={props.onSelected} data-value={props.value} data-clipboard-text={dataClipboardText} role="menuitem" >
      <a className="js-nav-system__subnav__link" href="#!" tabIndex={-1}>
        {props.fontAwesomeIcon &&
          <em className={fontAwesomeIconCSSclass} aria-hidden="true"></em>
        }
        <span>{text}</span>
        {props.isSelected &&
          <em className={emCSSclasses}></em>
        }
      </a>
    </li>
  );
};
